/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
    Response
} from '../../../../../_metronic/helpers'

import { getDLMSiteInspections } from '../_requests'
import { DLMSiteInspectionsListItem } from '../_models'
import { useDLMSiteInspectionsQueryRequest } from './DLMSiteInspectionsQueryRequestProvider'
import { useAuth } from '../../../auth'


const DLMSiteInspectionsQueryResponseContext = createResponseContext<DLMSiteInspectionsListItem>(initialQueryResponse)
const DLMSiteInspectionsQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useDLMSiteInspectionsQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
    

    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['DLMSiteInspections-LIST'],        
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else { 
                return getDLMSiteInspections();
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <DLMSiteInspectionsQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </DLMSiteInspectionsQueryResponseContext.Provider>
    )
}

const useDLMSiteInspectionsQueryResponse = () => useContext(DLMSiteInspectionsQueryResponseContext)

const useDLMSiteInspectionsQueryResponseData = () => {
    const {response} = useDLMSiteInspectionsQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useDLMSiteInspectionsQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useDLMSiteInspectionsQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useDLMSiteInspectionsQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMSiteInspectionsQueryResponse()
  return isLoading
}

export {
    DLMSiteInspectionsQueryResponseProvider,
    useDLMSiteInspectionsQueryResponse,
    useDLMSiteInspectionsQueryResponseData,
    useDLMSiteInspectionsQueryResponsePagination,
    useDLMSiteInspectionsQueryResponseLoading,
}


export type DLMSiteInspectionsQueryResponse = Response<Array<DLMSiteInspectionsListItem>>